import React from 'react';
import EmptyStateScope from 'shared/components/CategoryEmptyState';

const EmptyStateAppComponent = () => {
  return (
    <>
      {/* TODO - Move the strings to constants once category 4 items are merged */}
      <EmptyStateScope
        handleRedirect={() => {}}
        buttonTitle="Category 1"
        title="Complete Category 1 first to proceed with Category 4"
        subString="Oops! It looks like you've skipped a step. Please complete Category 1 first to proceed with Category 4. This ensures we have all the necessary information for calculation"
      />
    </>
  );
};

export default EmptyStateAppComponent;
